import Vue from "vue";
import Vuex from "vuex";
import { state, State } from "./state";
import Cookie from "js-cookie";

Vue.use(Vuex);

const store = new Vuex.Store({
  state,
  getters: {},
  mutations: {
    getUserName(state: State, userName: string): void {
      state.userName = userName;
    },
    getUserAvatar(state: State, userAvatar: string): void {
      state.userAvatar = userAvatar;
    },
    getPermissions(state: State, userPermissions: string[]): void {
      state.userPermissions = userPermissions;
    },
  },
  actions: {
    logout(): void {
      const DOMAIN: string = process.env.VUE_APP_DOMAIN;
      Cookie.remove("dock_web_id", { domain: DOMAIN });
      Cookie.remove("dock_web_name", { domain: DOMAIN });
      Cookie.remove("dock_web_token", { domain: DOMAIN });
      // Cookie.remove("dock_user_role", { domain: DOMAIN });
      location.reload();
    },
  },
});

export default store;
